import React, { useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import play_btn from "../../assets/img/play_btn.png";
import thumbnail from "../../assets/img/thumbnel.png";
import video from "../../assets/video/video.mp4";
import CreditCard from "../card/CreditCard";
import creditCardData from "../card/CreditCardData";
import PersonalProductCard from "../card/PersonalProductCard";
import personalProductData from "../card/PersonalProductData";

export default function FundingPersonal() {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handleTogglePlay = () => {
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  const [searchTerm, setSearchTerm] = useState("");
  const [bureaus, setBureaus] = useState({
    Experian: false,
    Equifax: false,
    TransUnion: false,
  });
  const [creditScore, setCreditScore] = useState(2); // Default slider value (Average)

  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleBureauChange = (e) => {
    const { name, checked } = e.target;
    setBureaus({ ...bureaus, [name]: checked });
  };

  const handleCreditScoreChange = (e) => setCreditScore(e.target.value);

  const handleSearch = () => {
    console.log("Search Term:", searchTerm);
    console.log("Selected Bureaus:", bureaus);
    console.log("Credit Score Level:", creditScore);
  };

  return (
    <div className="funding_personal">
      <div className="funding_overview mt-4 tradelines">
        <div className="funding_common_area">
          <div className="content">
            <h3>Access up to $1M+ in Credit Cards</h3>
            <div className="video-container relative mt-3">
              <video
                ref={videoRef}
                src={video}
                className="video"
                onClick={handleTogglePlay}
                preload="metadata"
              />
              {!isPlaying && (
                <div className="thumbnail-overlay flex justify-center items-center">
                  <img
                    src={thumbnail}
                    alt="Video Thumbnail"
                    className="thumbnail"
                  />
                  <div className="play-button" onClick={handleTogglePlay}>
                    <img className="icons" src={play_btn} alt="Play Button" />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row mt-4">
        <div className="col-lg-4">
          <div className="filter-container">
            <h3>Filter</h3>
            <div className="search-bar mt-3">
              <input
                type="text"
                placeholder="🔍 Search"
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>

            <div className="filter-section">
              <h4>Credit Bureaus</h4>
              <div className="list">
                <div className="checkbox">
                  <input
                    type="checkbox"
                    name="Experian"
                    checked={bureaus.Experian}
                    onChange={handleBureauChange}
                  />
                  <label>Experian</label>
                </div>
                <div className="checkbox">
                  <input
                    type="checkbox"
                    name="Equifax"
                    checked={bureaus.Equifax}
                    onChange={handleBureauChange}
                  />
                  <label>Equifax</label>
                </div>
                <div className="checkbox">
                  <input
                    type="checkbox"
                    name="TransUnion"
                    checked={bureaus.TransUnion}
                    onChange={handleBureauChange}
                  />
                  <label>TransUnion</label>
                </div>
              </div>
            </div>

            <div className="filter-section mt-3">
              <h4>Credit Score</h4>
              <div className="score-labels">
                <span>Limited</span>
                <span>Average</span>
                <span>Good</span>
                <span>Excellent</span>
              </div>
              <input
                type="range"
                min="1"
                max="4"
                value={creditScore}
                onChange={handleCreditScoreChange}
                className="slider"
              />
            </div>

            <button className="search-button" onClick={handleSearch}>
              Search
            </button>
          </div>
        </div>

        <div className="col-lg-8">
          <div className="card">
            <div className="card_header">
              <h3>High Limit Personal Credit Cards</h3>
              <IoMdClose className="icons" />
            </div>
            <div className="credit_card_list mt-3">
              {creditCardData.map((card) => (
                <CreditCard key={card.id} card={card} />
              ))}
            </div>
          </div>
        </div>

        <div className="col-lg-12">
          <div className="card">
            <div className="card_container">
              {personalProductData.map((card) => (
                <PersonalProductCard key={card.id} card={card} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
